


<template>
  <div class="stack_client_r_set_B">
    
    
    <div class="box recent">
      <div class="header"> <h2>📄 최근 보장분석</h2> <span>더보기 <i class="ph ph-caret-right"></i></span> </div>
      <ul>
        <li v-for="(file, index) in files" :key="index">
          <span>📌</span>
          <p>{{ file }}</p>
        </li>
      </ul>
    </div>

    
    <div class="box claim">
      <div class="header"> <h2>💵 고객 보험 청구</h2> </div>
      <div class="content"> <h2>접수 중 : 4건</h2> <p>접수대기 : 2건</p> </div>
      <button> 접수하기</button>
    </div>
    
    
    <div class="stacks">
      <div class="stack">
        <div class="thumb"> <img src="https://amadiary.com/pub/acon/ama_logo_bg.png"/> </div>
        <h2>AMA 성향<br>테스트</h2>
      </div>
      <div class="stack" style="background:black;">
        <div class="thumb"> <img src="https://amadiary.com/pub/edit_icon/chara_raining.png"/> </div>
        <h2>보험성향<br>테스트</h2>
      </div>
    </div>


  </div>
</template>




<script>
export default {
  data() {
    return {
      files: ["김영희_2025-04.pdf", "김옥자_2025-04.pdf", "오은영_2025-04.pdf", "쿠리삥뽕_2025-04.pdf"],
    }
  },
  methods: {
    clicked() {
    }
  }
}
</script>




<style scoped>

@media (max-width: 1280px) or (max-height: 800px) {
  .stack_client_r_set_B {
    
  }
}

@media (max-width: 1024px) or (max-height: 800px) {
  .stack_client_r_set_B {
    grid-template-columns: repeat(1, 1fr) !important;
    grid-template-rows : repeat(3, 1fr) !important;
    height:fit-content !important;
    padding:16px;
    box-sizing: border-box;
    gap:0 !important;
  }
}

ul {
  list-style: none;
  padding:0;
  margin:0;
}

h2 {
  font-size: 16px;
  font-weight: 600;
  padding:0;
  margin:0;
}

p {
  font-size: 14px;
  font-weight: 400;
  padding:0;
  margin:0;
}

.stack_client_r_set_B {
  position: relative;
  width: 100%;
  height: auto;
  display: flex;
  gap:24px;
}

.box {
  width:100%;
  height:100%;
  background: var(--color-surface);
  border-radius: 16px;
  padding:16px;
  box-sizing: border-box;
  display:flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  gap:12px;
  backdrop-filter: blur(24px);
}

.header {
  width:100%;
  height:30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header > h2 {
  font-size: 20px;
  font-weight: 600;
  padding:0;
  margin:0;
}

.header > span {
  font-size: 14px;
  font-weight: 400;
  padding:0;
  margin:0;
  cursor: pointer;
}

.stacks {
  width:100%;
  height:100%;
  display:flex;
  flex-direction: column;
  gap:24px;
}

.stacks > .stack {
  width: 100%;
  height: 100%;
  background: var(--color-surface);
  border-radius: 16px;
  padding:16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  gap:12px;
  backdrop-filter: blur(24px);
  cursor: pointer;
}

.stacks > .stack > .thumb {
  position: relative;
  min-width: 48px;
  width:48px;
  height: auto;
  aspect-ratio: 1/1 auto;
  border-radius: 12px;
  overflow: hidden;
}

.stacks > .stack > .thumb > img {
  position: absolute;
  width:100%;
  height:100%;
}

.recent > ul {
  width:100%;
  height:100%;
  display:flex;
  flex-direction: column;
  gap:12px;
  overflow: hidden;
}

.recent > ul > li {
  width:100%;
  height:48px;
  background:#fff;
  display:flex;
  gap:12px;
  justify-content: start;
  align-items: center;
  border-radius: 16px;
  padding:16px;
  box-sizing: border-box;
  cursor: pointer;
}

.recent > ul > li > span {
  width:24px;
  height:24px;
  display:flex;
  justify-content: center;
  align-items: center;
}

.recent > ul > li > p {
  width:100%;
  text-align: center;
  border-radius:50%;
  color:black;
}

.claim > .header {
  width:100%;
  height:30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color:var(--color-text-color);
}

.claim > .header > h2 {
  font-size: 20px;
  font-weight: 600;
  padding:0;
  margin:0;
}

.claim > .content {
  width:100%;
  height:100%;
  display:flex;
  flex-direction: column;
  gap:12px;
}

.claim > .content > h2 {
  font-size: 20px;
  font-weight: 800;
  color:var(--color-brand);
  padding:0;
  margin:0;
}

.claim > .content > p {
  font-size: 16px;
  font-weight: 400;
  padding:0;
  margin:0;
}

.claim > button {
  width:100%;
  height:48px;
  background: var(--color-brand);
  border: none;
  border-radius: 16px;
  padding:16px;
  box-sizing: border-box;
  color:var(--color-text-color);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}

</style>
